import { ActionCreator, createAction } from '@zervant/reactcomponents'

import { CollectionInterface } from '../Interfaces/CollectionInterface'
import { CustomerInterface } from '../Interfaces/CustomerInterface'
import { DocumentType, DraftInterface } from '../Interfaces/Draft/DraftInterface'
import { InvoiceItemType } from '../Interfaces/Draft/DraftItemType'
import { DraftFieldsInterface } from '../Interfaces/Draft/FieldsInterface'
import { EmailInterface } from '../Interfaces/EmailInterface'
import { EmailTemplateInterface } from '../Interfaces/EmailTemplateInterface'
import { EventInterface } from '../Interfaces/EventInterface'
import { ModalInterface } from '../Interfaces/ModalInterface'
import { NavigationInterface } from '../Interfaces/NavigationInterface'
import { ProductInterface } from '../Interfaces/ProductInterface'
import { SettingsInterface } from '../Interfaces/Settings/SettingsInterface'
import { TemplatesInterface } from '../Interfaces/TemplatesInterface'
import { TokenInterface } from '../Interfaces/TokenInterface'

export const ACTIONS = {
  ADD_EXAMPLE_LIST_ITEM: createAction<{ name: string }>('ADD_EXAMPLE_LIST_ITEM'),
  REMOVE_EXAMPLE_LIST_ITEM: createAction<{}>('REMOVE_EXAMPLE_LIST_ITEM'),
  SET_EXAMPLE_ITEM_MESSAGE: createAction<{}>('SET_EXAMPLE_ITEM_MESSAGE'),
  FINALIZE_SUBSCRIPTION: createAction<{}>('FINALIZE_SUBSCRIPTION'),
  NAVIGATE: createAction<NavigationInterface>('NAVIGATE'),

  /** @deprecated */
  NAVIGATE_ADD_MODAL: createAction<ModalInterface>('NAVIGATE_ADD_MODAL'),

  /**
   * @deprecated
   * note: subsequent actions should be handled in their respective modals instead of triggering them from
   * removeModal action
   */
  NAVIGATE_REMOVE_MODAL: createAction<{
    index: number
    action?: string
    payload?: any
  }>('NAVIGATE_REMOVE_MODAL'),

  ROUTER_CHANGE_LOCATION: createAction<string>('ROUTER_CHANGE_LOCATION'),
  LEGACY_CHANGE_STATE: createAction<{ [key: string]: string | number | boolean }>('LEGACY_CHANGE_STATE'),

  // Null action
  NULL_ACTION: createAction<null>('NULL_ACTION'),

  // Call this get the communications token
  LOAD_TOKEN: createAction<TokenInterface>('LOAD_TOKEN'),

  // Actions to load stuff from server resources
  LOAD_VITALS: createAction<null>('LOAD_VITALS'),

  /** @deprecated */
  LOAD_PRODUCTS: createAction<any, CollectionInterface<ProductInterface>>('LOAD_PRODUCTS'),

  /** @deprecated */
  NOTIFY_NEW_INVOICE_NUMBER: createAction<{ invoiceNumber: number }>('NOTIFY_NEW_INVOICE_NUMBER'),
  /** @deprecated */
  INVOICE_PREVIEW_LOADED: createAction<string>('INVOICE_PREVIEW_LOADED'),
  /** @deprecated */
  SELECT_SUBSCRIPTION: createAction<string>('SELECT_SUBSCRIPTION'),
  NEXT_SUBSCRIPTION_PAGE: createAction<{}>('NEXT_SUBSCRIPTION_PAGE'),
  PREVIOUS_SUBSCRIPTION_PAGE: createAction<{}>('PREVIOUS_SUBSCRIPTION_PAGE'),
  SUBSCRIPTION_DETAILS_NEXT: createAction<{
    name: string
    address: string
    contactPerson: string
    businessId: string
    language: string
    phone: string
    email: string
    iban: string
    promo: string
  }>('SUBSCRIPTION_DETAILS_NEXT'),
  SUBSCRIPTION_DETAILS_BACK: createAction<{
    name: string
    address: string
    contactPerson: string
    businessId: string
    language: string
    phone: string
    email: string
    iban: string
    promo: string
  }>('SUBSCRIPTION_DETAILS_BACK'),
  SUBSCRIPTION_RESET: createAction<{}>('SUBSCRIPTION_RESET'),
  LOAD_ACCOUNT_FEATURES: createAction<{ done: (payload: any) => void }>('LOAD_ACCOUNT_FEATURES'),
  SET_ACTIVE_POPUP: createAction<{ id: any; done: () => void }>('SET_ACTIVE_POPUP'),
}

export type ActionType = {
  [key in keyof typeof ACTIONS]?: (typeof ACTIONS)[key]
}
